import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { brand, nav } from "../data/siteContent";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-brand-greyBorder"
          : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <div className="container mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <button
          onClick={() => handleNav("home")}
          data-testid="header-logo"
          className="flex items-center gap-3"
        >
          <img
            src={brand.logo}
            alt="Alumak Doors & Windows"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNav(item.id)}
              data-testid={`nav-${item.id}`}
              className="text-sm font-medium text-brand-charcoal hover:text-brand-red transition-colors duration-200 tracking-wide"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${brand.phone}`}
            data-testid="header-phone"
            className="flex items-center gap-2 text-sm font-medium text-brand-charcoal hover:text-brand-red"
          >
            <Phone size={16} />
            {brand.phoneDisplay}
          </a>
          <button
            onClick={() => handleNav("contact")}
            data-testid="header-cta"
            className="bg-brand-red hover:bg-brand-redHover text-white px-6 py-3 text-xs font-semibold tracking-widest uppercase transition-colors"
          >
            Ζητήστε Προσφορά
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-brand-charcoal"
          aria-label="Μενού"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-brand-greyBorder px-6 py-6"
        >
          <div className="flex flex-col gap-4">
            {nav.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNav(item.id)}
                data-testid={`mobile-nav-${item.id}`}
                className="text-left text-base font-medium text-brand-charcoal hover:text-brand-red py-2 border-b border-brand-greyBorder"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("contact")}
              data-testid="mobile-cta"
              className="mt-4 bg-brand-red hover:bg-brand-redHover text-white px-6 py-4 text-xs font-semibold tracking-widest uppercase"
            >
              Ζητήστε Προσφορά
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
